import React from 'react';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';

function ChainedSaleCard({ name, count, image, onClick, actions }) {
    return (
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardActionArea
                onClick={onClick}
                sx={{
                    flexGrow: 1,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    justifyContent: 'flex-start',
                }}
            >
                <Box
                    sx={{
                        height: 260,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'linear-gradient(135deg, rgba(123,47,247,0.22), rgba(10,10,11,0.08))',
                        backgroundImage: image ? `url(${image})` : undefined,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                >
                    {!image && <FolderOutlinedIcon sx={{ fontSize: 96, color: 'primary.main', opacity: 0.85 }} />}
                </Box>
                <CardContent sx={{ flexGrow: 1, width: '100%' }}>
                    <Typography variant="h6" gutterBottom noWrap title={name}>
                        {name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {count} {count === 1 ? 'producto' : 'productos'}
                    </Typography>
                </CardContent>
            </CardActionArea>
            {actions && <CardActions sx={{ px: 2, pb: 2 }}>{actions}</CardActions>}
        </Card>
    );
}

export default ChainedSaleCard;
